import { useRef, useState } from "react";
import { motion } from "framer-motion";

export const BookCover = () => {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const onMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    setTilt({ x: -py * 9, y: px * 12 });
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={() => setTilt({ x: 0, y: 0 })}
      className="relative flex justify-center"
      style={{ perspective: "1400px" }}
      data-testid="book-cover-3d"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[440px] h-[440px] rounded-full bg-[#C5A059]/12 blur-[110px] pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 80, rotateY: -50 }}
        animate={{ opacity: 1, y: 0, rotateY: -16 }}
        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 1 }}
        style={{ transformStyle: "preserve-3d" }}
      >
        <motion.div
          animate={{ rotateX: tilt.x, rotateY: -16 + tilt.y }}
          transition={{ type: "spring", stiffness: 120, damping: 18 }}
          className="relative w-[280px] h-[424px] sm:w-[310px] sm:h-[470px]"
          style={{ transformStyle: "preserve-3d" }}
        >
          {/* Lomo */}
          <div
            className="absolute left-0 top-0 h-full w-[30px] bg-gradient-to-b from-[#16161f] via-[#0c0c12] to-[#16161f]"
            style={{ transform: "rotateY(-90deg) translateZ(15px)", transformOrigin: "left center" }}
          >
            <div className="h-full flex items-center justify-center">
              <span className="font-display font-medium text-[10px] tracking-[0.3em] text-[#C5A059]/90 uppercase" style={{ writingMode: "vertical-rl", transform: "scaleX(-1)" }}>
                Juega Tu Partido · Edgar Merino Vidangossy
              </span>
            </div>
          </div>
          {/* Cantos (páginas) */}
          <div
            className="absolute right-0 top-[3px] h-[calc(100%-6px)] w-[28px] bg-gradient-to-r from-[#d8d2c4] to-[#b0aa9c]"
            style={{ transform: "rotateY(90deg) translateZ(calc(100% - 15px)) translateX(-14px)", transformOrigin: "right center" }}
          />
          {/* Portada real */}
          <div
            className="absolute inset-0 overflow-hidden border border-[#C5A059]/20"
            style={{ transform: "translateZ(15px)" }}
          >
            <img src="/cover.jpg" alt="Portada de Juega Tu Partido, de Edgar Merino Vidangossy" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/[0.02] to-white/[0.09] pointer-events-none" />
          </div>
          {/* Sombra proyectada */}
          <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 w-[75%] h-10 bg-black/70 blur-2xl rounded-full" style={{ transform: "translateZ(-40px)" }} />
        </motion.div>
      </motion.div>
    </div>
  );
};
